import { COLORS } from '@btime/constants'
import React from 'react'

import { Title, SmallText } from '../../../../../components/presentation/Text'
import Separator from '../../../../../components/helpers/Separator'

const PageHeader = () => {
  return (
    <>
      <Title size="h3" color={COLORS.dark3} noWrap>
        Técnicos Cadastrados
      </Title>
      <SmallText>Visualize os técnicos cadastrados no sistema</SmallText>
      <Separator weight={2} />
    </>
  )
}

export default PageHeader
